// Deterministic string-hash + seeded PRNG. Used by anything that must place
// the same thing in the same spot every render (a module's star in
// AmbientCanvas, the generative starfield in CosmicBackdrop). These are STILL
// generators — same input → same output — so the visuals never reflow or
// shuffle between loads. No animation, no time, no randomness from outside.

// hash32 — FNV-1a, a small deterministic string hash. Maps an identity string
// (a galaxy account login, a module path) to a stable 32-bit unsigned int.
export function hash32(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

// mulberry32 — a tiny, fast, seedable PRNG. Returns a generator that yields a
// deterministic stream of floats in [0, 1). Seed it from hash32(identity) to
// get a stable-but-varied sequence per galaxy: same seed → identical stream, so
// a seeded backdrop is reproducible (and testable) rather than random.
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
